// src/hooks/useFileUpload.js
import { useState, useCallback } from 'react';
import { extractTextFromFile } from '@services/fileParser';
import { FILE_CONFIG } from '@config/constants';

export function useFileUpload() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [hasFile, setHasFile] = useState(false);
  const [parsedContent, setParsedContent] = useState(null);

  const uploadFile = useCallback(async file => {
    setIsLoading(true);
    setError(null);
    setParsedContent(null);

    try {
      if (!file) throw new Error('No file selected.');
      if (file.size > FILE_CONFIG.maxSize) {
        throw new Error(
          `File too large. Max is ${(FILE_CONFIG.maxSize / (1024 * 1024)).toFixed(1)} MB`
        );
      }

      const text = await extractTextFromFile(file);
      if (!text || text.trim().length < 10) {
        throw new Error('Could not extract readable text from the file.');
      }

      setParsedContent({
        name: file.name,
        size: file.size,
        type: file.type || 'unknown',
        text,
      });
      setHasFile(true);
    } catch (err) {
      console.error('Upload parse error:', err);
      setError(err?.message || 'Upload failed.');
      setHasFile(false);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    isLoading,
    error,
    hasFile,
    parsedContent,
    uploadFile,
  };
}

export default useFileUpload;
